<template>
  <Loader :loader="loaderActive"/>
  <vue-final-modal
      v-model="showModal"
      @click-outside="modalClose"
      classes="modal-container"
      content-class="modal-content">
    <div class="modal__result-header">
      <span class="close-btn" @click="modalClose">
        <span>x</span>
      </span>
    </div>
    <div class="modal__result-details">
      <div class="friend-title">
        বন্ধু সিলেক্ট করুন
      </div>
    </div>
    <div class="modal__result-list">
      <div class="friend-list">
        <div class="friend-content"  v-for="friend in friendList" :key="friend.user_id"
             :class="{'active': selectFriend === friend.user_id}"
             @click="challengeFriend(friend.user_id)">
          <img :src="friend.image_url" :alt="friend.name">
          <div class="friend-name">{{ friend.name }}</div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center" v-if="selectFriend">
      <argon-button
          color="dark"
          variant="gradient"
          class="my-4"
          @click="challenge"
          style="background: #F42F75;">Next
      </argon-button>
    </div>
  </vue-final-modal>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import {VueFinalModal} from 'vue-final-modal';
import ArgonButton from "@/components/ArgonButton.vue";

export default {
  name: "FriendListModal",
  props: ['modalShow'],
  components: {
    VueFinalModal,
    Loader,
    ArgonButton,
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      showModal: this.modalShow,
      friendList: [],
      selectFriend: '',
    }
  },
  created() {
    this.getFriendList();
  },
  methods: {
    modalClose() {
      this.emitter.emit('friend-list-modal-close-event', {'eventContent': false});
    },
    getFriendList() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/friends', {type: 'friends'}, this.config)
          .then( response => {
            this.loaderActive = false;
            this.friendList = response.data.friend_list;
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    challengeFriend(friend_id) {
      if (this.selectFriend === friend_id) {
        this.selectFriend = '';
        return;
      }
      this.selectFriend = friend_id;
    },
    challenge() {
      this.modalClose();
      this.$router.push({ name: 'ChallengeFriend', query: {friend_id: this.selectFriend} })
    }
  }
}
</script>

<style scoped>
:deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
}

.dark-mode div:deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
